var map = {
	"./01.jpg": 2070,
	"./04.jpg": 6927,
	"./1.jpg": 1742,
	"./10.jpg": 3412,
	"./20.jpg": 1701,
	"./21.jpg": 4440,
	"./26.jpg": 7275,
	"./27.jpg": 814,
	"./28.jpg": 5821,
	"./30.jpg": 7310,
	"./33.jpg": 393,
	"./34.jpg": 9706,
	"./4.jpg": 6039,
	"./5.jpg": 4874,
	"./7.jpg": 5112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5861;